import { createFileRoute } from '@tanstack/react-router';
import { McpPage } from '@/components/admin/mcp/McpPage.tsx';

export const Route = createFileRoute('/_app/admin/mcp')({
  staticData: { orgScope: 'none' },
  component: McpPage,
});
